module.exports = __webpack_public_path__ + "img/brand-13.511515e6.png";